var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMortgage140 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 140,
  height: 140,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M60.5 56a.5.5 0 0 0-.5.5v20a.5.5 0 0 0 .5.5h20a.5.5 0 0 0 .5-.5v-20a.5.5 0 0 0-.5-.5h-20ZM80 76H61V57h19v19ZM26.5 66a.5.5 0 0 1 .5.5V126h31V92.5a.5.5 0 0 1 .5-.5h24a.5.5 0 0 1 .5.5V126h31V66.5a.5.5 0 0 1 1 0v60a.5.5 0 0 1-.5.5h-88a.5.5 0 0 1-.5-.5v-60a.5.5 0 0 1 .5-.5ZM82 126H59V93h23v33Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-decorative-coral)",
  fillRule: "evenodd",
  d: "M70.812 14.11a.5.5 0 0 0-.624 0L35 42.26V22.5a.5.5 0 0 0-1 0v20.56L10.188 62.11a.5.5 0 1 0 .624.78L34.81 43.692c.002 0 .003-.002.004-.003L70.5 15.14l59.688 47.75a.499.499 0 1 0 .624-.78l-60-48Z",
  clipRule: "evenodd"
})));
export { SvgMortgage140 as ReactComponent };
export default __webpack_public_path__ + "6fbbbc7538b2768256d4494db1042b9e.svg";